import AlertComponent from '../alert-component';

import { useTranslation } from '@hooks/use-translations';

import styles from './general-error-message.module.scss';

const GeneralErrorMessage = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.errorContainer}>
      <AlertComponent message={t('cart.error.message')} variantType="error" />
    </div>
  );
};

export default GeneralErrorMessage;
